import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-617e7376"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "conversation-box"
}
const _hoisted_2 = { class: "animate conversation-header" }
const _hoisted_3 = {
  key: 0,
  class: "notification"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"40px"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"text-decoration":"none !important"} }, "Para visualizar anteriores, ve a sección mensajería.", -1))
const _hoisted_6 = {
  key: 0,
  class: "friend-dialog-container"
}
const _hoisted_7 = { class: "friend-dialog" }
const _hoisted_8 = {
  key: 1,
  class: "my-dialog-container"
}
const _hoisted_9 = { class: "my-dialog" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"100px"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"40px"} }, null, -1))
const _hoisted_12 = { class: "type-text" }
const _hoisted_13 = {
  key: 1,
  style: {"margin-bottom":"0px","width":"350px","text-align":"center","height":"40px"}
}
const _hoisted_14 = { class: "conversation-header" }
const _hoisted_15 = {
  key: 0,
  class: "notification"
}

import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useConversations } from '@/store/useConversations';
import { useAuth } from '@/store/useAuth';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationChat',
  props: ['conversation'],
  setup(__props) {

const maximize = ref(true)
const storeConversations = useConversations()
const props = __props
const message = ref('')
const store = useAuth()
const objDiv = ref()
const unreads = computed(() => {
    let count = 0;
    for (let i = 0; i <= storeConversations.max_amount_messages; i++) {
        if ((props.conversation.messages[i]) && (props.conversation.messages[i].sender == props.conversation.id) && (props.conversation.messages[i].is_read == 0)) {
            count++
        }
    }
    if(count > 99) {
        count = 99
    }
    return count
})

const intervalId = window.setInterval(async () => {
    if (!store.token) {
        return
    }
    storeConversations.updateConversation(store.token, props.conversation.id)
}, 5000)

const close = () => {
    storeConversations.removeConversation(props.conversation.id)
}

onUnmounted(() => {
    clearInterval(intervalId);
})

onMounted(() => {
    objDiv.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
})

const markAsRead = async () => {
    if(!store.token) {
        return
    }
    storeConversations.markAsRead(store.token, props.conversation.id)
}

const sendMessage = async () => {
    if (!store.token) {
        return
    }
    const response = await storeConversations.sendMessage(store.token, props.conversation.id, message.value)
    objDiv.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
    message.value = ''
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (maximize.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (unreads.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(unreads.value), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(props.conversation.username) + " ", 1),
          _createVNode(_component_v_icon, {
            name: "ri-close-circle-fill",
            fill: "white",
            style: {"float":"right","cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
          }),
          _createVNode(_component_v_icon, {
            name: "la-window-minimize-solid",
            fill: "white",
            style: {"float":"right","cursor":"pointer","margin-right":"3px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (maximize.value = false))
          })
        ]),
        _createElementVNode("div", {
          style: {"overflow-y":"scroll"},
          ref_key: "objDiv",
          ref: objDiv
        }, [
          _hoisted_4,
          _createVNode(_component_RouterLink, {
            to: {name:'messages', params: {id: props.conversation.id}},
            style: {"text-decoration":"none !important"}
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.conversation.messages, (message, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (message.sender == props.conversation.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", null, _toDisplayString(message.message), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", null, _toDisplayString(message.message), 1)
                    ])
                  ]))
            ]))
          }), 128)),
          _hoisted_10
        ], 512),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Escribir mensaje...",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
            onKeyup: _withKeys(sendMessage, ["enter"]),
            onFocus: markAsRead,
            max: "255"
          }, null, 544), [
            [_vModelText, message.value]
          ]),
          _createElementVNode("button", { onClick: sendMessage }, "Enviar")
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (unreads.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(unreads.value), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(props.conversation.username) + " ", 1),
          _createVNode(_component_v_icon, {
            name: "ri-close-circle-fill",
            fill: "white",
            style: {"float":"right","cursor":"pointer"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (close()))
          }),
          _createVNode(_component_v_icon, {
            name: "fa-regular-window-maximize",
            fill: "white",
            style: {"float":"right","cursor":"pointer","margin-right":"3px"},
            onClick: _cache[4] || (_cache[4] = ($event: any) => (maximize.value = true))
          })
        ])
      ]))
}
}

})